import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily, basePadding } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: baseColors.white
    },
    content: {
        marginVertical: 20
    },
    header: {
        marginBottom: 25
    },
    title: {
        color: baseColors.green.primary,
        marginBottom: 12
    },
    missionLabel: {
        color: baseColors.black,
        marginBottom: 20
    },
    videoContainer: {
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 10
    },
    videos: {
        marginTop: 20
    }
})

export default styles
